module.exports = __webpack_public_path__ + "img/improvement.3b237fed.svg";